import { useNavigate } from 'react-router-dom';
import HomeScreenButton from '../atoms/HomeScreenButton';
import { HomeScreenButtonConfig, HomeScreenButtonProps } from '../atoms/HomeScreenButton.types';

const SelfObservationHomeScreenButton = ({ customLabel, customIcon }: HomeScreenButtonConfig) => {
    const navigate = useNavigate();

    const buttonProps: HomeScreenButtonProps = {
        label: customLabel || 'Tagebuch',
        iconPath: 'icon_protocol_homescreen.svg',
        customIconSvg: customIcon
    };

    return (
        <HomeScreenButton
            buttonProps={buttonProps}
            action={() => navigate('self-observation')}
            isHidden={false}
            disabled={false}
        />
    );
};
export default SelfObservationHomeScreenButton;